import { login } from '../api';
import { useState } from 'react';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';

export const useLogin = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (email: string, password: string) => {
    setStatus('loading');
    try {
      const response = await login(email, password);
      const { refresh, access } = response.data as {
        refresh: string;
        access: string;
      };
      localStorage.setItem('refresh_token', refresh);
      localStorage.setItem('access_token', access);
      setStatus('success');
    } catch (error) {
      setStatus('failed');
      if (isAxiosError(error)) {
        const errorMessage = error.response?.data.detail;
        if (errorMessage) {
          return setError(errorMessage);
        }
      }
      setError('Something went wrong');
    }
  };

  return { status, error, handleLogin, setError };
};
